import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Dialog } from '../../components/Dialog';
import { Spinner } from '../../components/Spinner';
import * as deere from '../../services/deere-service';
import { FilterSelector } from '../../components/FilterSelector';
import { useAlerts } from '../../hooks/use-alerts';

Connect.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConnected: PropTypes.func.isRequired,
  grower: PropTypes.shape({
    guid: PropTypes.string.isRequired,
    operationName: PropTypes.string.isRequired,
  }).isRequired,
};

export function Connect(props) {
  const { onCancel, onConnected, grower } = props;
  const [partners, setPartners] = useState();
  const [selectedPartner, setSelectedPartner] = useState(0);
  const { showError } = useAlerts();

  useEffect(() => {
    deere.getPartners().then((results) =>
      setPartners(
        results.map((partner) => ({
          ...partner,
          name: `${partner.name} (${partner.id})`,
        })),
      ),
    );
  }, []);

  return (
    <Dialog
      title={`Select the Deere organization you wish to connect to ${grower.operationName}`}
      onCancel={onCancel}
      onSave={connectOrganization}
      canSave={Boolean(selectedPartner)}
    >
      <Box sx={{ height: 200 }}>
        {buildSelector()}
        {buildRedirectNotice()}
      </Box>
    </Dialog>
  );

  function buildRedirectNotice() {
    if (!selectedPartner?.connectUrl) return;

    return (
      <Typography variant="subtitle2">
        You will be redirected to Operations Center to complete the connection
        upon Save
      </Typography>
    );
  }

  function buildSelector() {
    if (!partners) return <Spinner />;

    if (!partners.length)
      return (
        <Typography>
          There are no organizations that are partnered with Advanced Agrilytics
        </Typography>
      );

    return (
      <FilterSelector
        sx={{ ml: '0 !important', mb: 2, width: 400 }}
        dark={false}
        isVisible
        selectedOption={selectedPartner}
        options={partners}
        onChange={(selected) => setSelectedPartner(selected)}
        sortKeys={['name']}
        optionLabelKey="name"
        optionKey="id"
        optionContentKey="name"
        inputLabel="Organization"
      />
    );
  }

  async function connectOrganization() {
    await deere
      .connect(grower, selectedPartner.id)
      .then(() => onConnected(selectedPartner.name))
      .catch(showError);
  }
}
